import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vue2TouchEvents from 'vue2-touch-events';
import VueConfirmDialog from 'vue-confirm-dialog';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/style.css';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import VeeValidate from 'vee-validate';
import responsive from 'vue-responsive';
import BackToTop from 'vue-backtotop';

import PrimeVue from 'primevue/config';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import Card from 'primevue/card';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Panel from 'primevue/panel';
import Toolbar from 'primevue/toolbar';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import FileUpload from 'primevue/fileupload';
import InputSwitch from 'primevue/inputswitch';
import InputNumber from 'primevue/inputnumber';
import Password from 'primevue/password';
import Dialog from 'primevue/dialog';
import Message from 'primevue/message';
import InlineMessage from 'primevue/inlinemessage';
import ProgressSpinner from 'primevue/progressspinner';
import CheckBox from 'primevue/checkbox';
import Dropdown from 'primevue/dropdown';
import Tag from 'primevue/tag';
import PickList from 'primevue/picklist';

import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';

import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {
    faHome,
    faUser,
    faUserPlus,
    faTrophy,
    faDice,
    faSignInAlt,
    faSignOutAlt,
    faAngleLeft,
    faAngleRight,
    faEdit,
    faMedal,
    faCrown,
    faAngleUp,
    faAngleDown,
    faRedoAlt,
    faCheckCircle
} from '@fortawesome/free-solid-svg-icons';

library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt, faAngleRight, faAngleLeft, faEdit, faDice, faTrophy, faMedal, faCrown, faAngleUp, faAngleDown, faRedoAlt, faCheckCircle);

Vue.config.productionTip = false;
Vue.use(PrimeVue);
Vue.use(VeeValidate);
Vue.use(VueConfirmDialog);
Vue.use(responsive);
Vue.use(BackToTop);
Vue.use(Vue2TouchEvents);

Vue.component('DataTable', DataTable);
Vue.component('DataView', DataView);
Vue.component('Column', Column);
Vue.component('Card', Card);
Vue.component('vue-confirm-dialog', VueConfirmDialog.default);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('InputText', InputText);
Vue.component('Button', Button);
Vue.component('Panel', Panel);
Vue.component('Toolbar', Toolbar);
Vue.component('Accordion', Accordion);
Vue.component('AccordionTab', AccordionTab);
Vue.component('TabView', TabView);
Vue.component('TabPanel', TabPanel);
Vue.component('FileUpload', FileUpload);
Vue.component('InputSwitch', InputSwitch);
Vue.component('InputNumber', InputNumber);
Vue.component('Password', Password);
Vue.component('Dialog', Dialog);
Vue.component('Message', Message);
Vue.component('InlineMessage', InlineMessage);
Vue.component('ProgressSpinner', ProgressSpinner);
Vue.component('CheckBox', CheckBox);
Vue.component('Dropdown', Dropdown);
Vue.component('Tag', Tag);
Vue.component('PickList', PickList);

Vue.filter('numFormat', numFormat(numeral));

// Vue.prototype.$inMaintenance;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
